import React from 'react';

const WEEKDAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const pad = (n) => String(n).padStart(2, '0');
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export default function Calendar({ cursor, selected, marked, onSelect, onPrev, onNext }) {
  const year = cursor.getFullYear();
  const month = cursor.getMonth();
  const startDow = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const today = ymd(new Date());

  const cells = [];
  for (let i = 0; i < startDow; i += 1) cells.push(null);
  for (let day = 1; day <= daysInMonth; day += 1) cells.push(day);

  return (
    <div className="aj-cal">
      <div className="aj-cal-head">
        <button type="button" className="aj-cal-nav" onClick={onPrev} aria-label="Previous month">
          ‹
        </button>
        <div className="aj-cal-title">
          {MONTHS[month]} {year}
        </div>
        <button type="button" className="aj-cal-nav" onClick={onNext} aria-label="Next month">
          ›
        </button>
      </div>

      <div className="aj-cal-grid aj-cal-dow">
        {WEEKDAYS.map((w, i) => (
          <span key={i} className="aj-dow">
            {w}
          </span>
        ))}
      </div>

      <div className="aj-cal-grid">
        {cells.map((day, i) => {
          if (day == null) return <span key={`e${i}`} className="aj-cell aj-empty" />;
          const ds = `${year}-${pad(month + 1)}-${pad(day)}`;
          const cls = ['aj-cell'];
          if (ds === selected) cls.push('is-selected');
          if (ds === today) cls.push('is-today');
          if (marked.has(ds)) cls.push('has-entries');
          return (
            <button type="button" key={ds} className={cls.join(' ')} onClick={() => onSelect(ds)}>
              <span className="aj-cell-num">{day}</span>
              {marked.has(ds) && <span className="aj-dot" aria-hidden="true" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
